import { createSlice } from "@reduxjs/toolkit";

import { Vehicle } from "../types/Vehicle";
import { RootState } from ".";

interface BookingState {
  vehicles: Vehicle[];
}

const initialState: BookingState = {
  vehicles: [],
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setVehicles: (state, action) => {
      state.vehicles = action.payload;
    },
  },
});

export const { setVehicles } = bookingSlice.actions;

export const selectVehicles = (state: RootState) => state.booking.vehicles;
